import { styled } from "styled-components";

const ResultWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const ResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }): string => theme.spacing[2.25]};
  max-width: 390px;
  text-align: center;
`;

export { ResultContainer, ResultWrapper };
